/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Commission_Action_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not update the commission entries." |
*
* @param {Partner_Admin_Commission_Action_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_action_error = /** @type {((inputs?: Partner_Admin_Commission_Action_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Action_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Provisionseinträge konnten nicht aktualisiert werden.")
	return /** @type {LocalizedString} */ ("Could not update the commission entries.")
});